import clsx from 'clsx'
import Link from 'next/link'
import { type ComponentProps, type ReactNode } from 'react'
import { xStack } from 'ui/src/patterns/stack'
import { activeItem, item } from './ArticleCategoryList.css'

const Root = (props: { children: ReactNode }) => {
  return (
    <div className={xStack({ gap: 'xxs', alignItems: 'center', justifyContent: 'center', flexWrap: 'wrap' })}>
      {props.children}
    </div>
  )
}

const Item = ({ className, active, ...forwardedProps }: { active?: boolean } & ComponentProps<typeof Link>) => (
  <Link className={clsx(className, item, active && activeItem)} {...forwardedProps} />
)

export const ArticleCategoryList = {
  Root,
  Item,
} as const
